// extracted by mini-css-extract-plugin
export default {"logo":"Login_logo__nsi8D","head":"Login_head__oB8WC","form":"Login_form__VBZH-","btncontainer":"Login_btncontainer__IB66p","alrdrgstr":"Login_alrdrgstr__-nduA"};